import { Link, Typography } from "@mui/material";
import { URLS } from "../../../config/const/enums.js";
// import useSharedData from "../../../hooks/useSharedData.js";
import {
	Section,
	OneColumnStack,
	TitleSubTitle,
	//   AccordionPanel,
} from "@arp/react-ndbx";

//TODO: PUT BACK
import AccordionPanel from "../../coding/AccordionPanel.jsx";
import { useState } from "react";
//TODO: PUT BACK/
//----------------------------------------------------------------

const AdditionalOwnerDisclaimerAccordion = () => {
	// const { pdsUrl } = useSharedData();
	const [expanded, setExpanded] = useState(false);

	const handleAccordionClick = () => {
		setExpanded(!expanded);
	};

	return (
		<AccordionPanel
			mt={{ sm: 2, md: 6 }}
			width={{ md: 470 }}
			label="Are you interested in an additional Policy Owner?"
			stackMargin={{ xs: 2, sm: 0, md: 0 }}
			summaryMargin={{ xs: 0, sm: 0 }}
			topBorderOpacity={0}
			onClickHandler={handleAccordionClick}
			expanded={expanded}
		>
			{[
				<>
					<OneColumnStack align="left">
						{/* <TitleSubTitle
							title="If you’d like to have a joint life policy, contact us"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle> */}
						{/* <Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								We’re updating our systems and currently unable to complete a
								joint life policy online, but we’re here to help.
							</Typography>
						</Section> */}
						{/* <Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								You can complete this quote and purchase it as a single Life
								Insured, then contact us on{" "}
								<Link href={URLS.CONTACT_US_PHONE_URL}>
									{URLS.CONTACT_US_PHONE_NUMBER}
								</Link>{" "}
								to arrange for the second applicant to be quoted and added to
								the policy. Alternatively, we can help with the quote process
								for both of you over the phone.
							</Typography>
						</Section> */}
						{/* <Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Note: We’ll need you to be both available on the phone if you
								contact us. Both of you will also become Policy Owners on the
								policy.
							</Typography>
						</Section> */}

						<TitleSubTitle
							title="If you’d like to have an additional Policy Owner"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle>

						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Complete the{" "}
								<Link
									href={URLS.ADDITIONAL_POLICY_OWNER_FORM_URL}
									target="_blank"
								>
									Addition of Policy Owner Form
								</Link>
								. Note this additional Policy Owner won’t be a Life Insured
								under the policy. You may do this now or at a future time, this
								form is available on our{" "}
								<Link href={URLS.POLICY_OUTCOME} target="_blank">
									website
								</Link>
								.
							</Typography>
						</Section>
						<TitleSubTitle
							title="Important information about Policy Owners:"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle>

						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Where there are two Policy Owners under the policy, we’ll pay
								the death benefit to the surviving Policy Owner.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								The request of one Policy Owner will bind all Policy Owners.
								There's a maximum of two Policy Owners per Life Insurance
								Policy.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								A Policy Owner will have all rights over the policy and may
								request changes on behalf of any other Policy Owner.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Requested changes may include, but not limited to:
								<ul>
									<li>decrease of cover(s)</li>
									<li>removal of cover(s) or a Policy Owner</li>
									<li>cancellation of the policy</li>
									<li>updating contact details</li>
								</ul>
							</Typography>
						</Section>
					</OneColumnStack>
				</>,
			]}
		</AccordionPanel>
	);
};

export default AdditionalOwnerDisclaimerAccordion;
